import ColumnItem from "./ColumnItem";

export default ColumnItem;
